import { getDataMapper, makeHttpRequest, mapField } from "@/shared";

const mapStatsFromServer = getDataMapper({
    open: mapField("open", Number),
    resolvedTotal: mapField("resolved_total", Number),
    resolvedWeek: mapField("resolved_week", Number),
    resolvedMonth: mapField("resolved_month", Number),
    avgResolutionMinutes: mapField("avg_resolution_minutes", Number),
    repeatCount: mapField("repeat_count", Number),
});

export const getIssuesStats = async () => {
    const response = (
        await makeHttpRequest({
            url: "admin/issues/stats",
            method: "GET",
        })
    ).data;

    return mapStatsFromServer(response.data);
};
